import axios from "axios"
import moment from "moment"

/* BASE URL */
export const SITE_URL = process.env.REACT_APP_API_URL

export const BASE_URL = SITE_URL + "/api"
export const UPLOADS_URL = SITE_URL + "/uploads/"

/* BACKEND API URLS */
export const API_ADMIN_CHECK_SESSION = BASE_URL + "/sess"
export const API_ADMIN_LOGIN = BASE_URL + "/login"
export const API_ADMIN_LOGOUT = BASE_URL + "/signout"
export const API_ADMIN_AUTH = BASE_URL + "/auth"
export const API_ADMIN_CUSTOMERS = BASE_URL + "/m/users"
export const API_ADMIN_CHATS = BASE_URL + "/m/users"
export const API_ADMIN_PRODUCTS = BASE_URL + "/m/products"
export const API_ADMIN_SHIPMENTS = BASE_URL + "/m/shipments"
export const API_ADMIN_PURCHASES = BASE_URL + "/m/purchases"
export const API_ADMIN_PRODUCT_STOCK = BASE_URL + "/m/products/inventory"
export const API_ADMIN_REPLY_TEMPLATES = BASE_URL + "/m/notificationTemplates"
export const API_ADMIN_SCHEDULES = BASE_URL + "/m/schedule"
export const API_ADMIN_SETTINGS = BASE_URL + "/m/settings"
export const API_ADMIN_PICKUP_LIMIT = BASE_URL + "/m/settings/layawayTime"
export const API_ADMIN_RICHMENUS = BASE_URL + "/m/settings/richmenus"
export const API_ADMIN_TAX = BASE_URL + "/m/settings/tax"
export const API_PUBLIC_CATEGORIES = BASE_URL + "/products/categories"
export const API_PUBLIC_SETTINGS = BASE_URL + "/settings"

// SMAREGI URL AND CONFIG
export const SMAREGI_URL = process.env.REACT_APP_SMAREGI_CLIENT_URL
export const SMAREGI_RESPONSE_TYPE = "code"
export const SMAREGI_CLIENT_ID = process.env.REACT_APP_SMAREGI_CLIENT_ID
export const SMAREGI_SCOPE = "openid email profile offline_access"
export const SMAREGI_STATE = [...Array(30)]
  .map(() => Math.random().toString(36)[2])
  .join("")
export const SMAREGI_REDIRECT_URI = process.env.REACT_APP_SMAREGI_REDIRECT_URI

/* SETTINGS KEY */
export const SETTINGS_KEY_FREE_SHIPMENT_ENABLED = "freeShipmentEnabled"
export const SETTINGS_KEY_FREE_SHIPMENT_FROM = "freeShipmentFrom"
export const SETTINGS_KEY_SHIPMENT_TRACKING_URL = "shipmentTrackingUrl"
export const SETTINGS_KEY_GIFT_POINT_NEW_REGISTER = "giftPointNewRegister"
export const SETTINGS_KEY_GIFT_POINT_LINE_SYNC = "giftPointLineSync"

/* SETTINGS LABEL */
export const SETTINGS_LABEL_FREE_SHIPMENT_ENABLED = "送料無料"
export const SETTINGS_LABEL_FREE_SHIPMENT_FROM = "送料無料条件"
export const SETTINGS_LABEL_SHIPMENT_TRACKING_URL = "荷物問い合わせ先URL"
export const SETTINGS_LABEL_GIFT_POINT_NEW_REGISTER = "新規登録ギフトポイント"
export const SETTINGS_LABEL_GIFT_POINT_LINE_SYNC = "LINE連携ギフトポイント"

/* QUERY KEY */
export const QUERY_KEY_ADMIN_CHECK_SESSION = "ADMIN_CHECK_SESSION"
export const QUERY_KEY_ADMIN_AUTH = "ADMIN_AUTH"
export const QUERY_KEY_ADMIN_CUSTOMERS = "ADMIN_CUSTOMERS"
export const QUERY_KEY_ADMIN_PRODUCTS = "ADMIN_PRODUCTS"
export const QUERY_KEY_ADMIN_PRODUCTS_LIST = "ADMIN_PRODUCTS_LIST"
export const QUERY_KEY_ADMIN_CATEGORIES = "ADMIN_CATEGORIES"
export const QUERY_KEY_ADMIN_SHIPMENTS = "ADMIN_SHIPMENTS"
export const QUERY_KEY_ADMIN_PURCHASES = "QUERY_KEY_ADMIN_PURCHASES"
export const QUERY_KEY_ADMIN_PRODUCT_STOCK = "QUERY_KEY_ADMIN_PRODUCT_STOCK"
export const QUERY_KEY_ADMIN_REPLY_TEMPLATES = "ADMIN_REPLY_TEMPLATES"
export const QUERY_KEY_ADMIN_PICKUP_LIMIT = "ADMIN_PICKUP_LIMIT"
export const QUERY_KEY_ADMIN_HOLIDAYS = "ADMIN_HOLIDAYS"
export const QUERY_KEY_ADMIN_NO_TASTE_DAYS = "ADMIN_NO_TASTE_DAYS"
export const QUERY_KEY_ADMIN_RICHMENUS = "ADMIN_RICHMENUS"
export const QUERY_KEY_ADMIN_SETTINGS = "ADMIN_SETTINGS"
export const QUERY_KEY_ADMIN_POINT_SETTINGS = "ADMIN_POINT_SETTINGS"
export const QUERY_KEY_ADMIN_TAX_SETTINGS = "ADMIN_TAX_SETTINGS"
export const QUERY_KEY_ADMIN_CHATS = "ADMIN_CHATS"

/* AXIOS CONFIG */
export const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
})
/* SOCKET PATH */
export const SOCKET_PATH = "/socket.io"
export const SOCKET_CHAT = "chat"
export const SOCKET_MEMBER = "member"

/* BACKEND API REQUESTS */
export async function ADMIN_LOGIN(data) {
  return await axiosInstance.post(API_ADMIN_LOGIN, data)
}

export async function ADMIN_LOGOUT() {
  return await axiosInstance.get(API_ADMIN_LOGOUT)
}

export async function ADMIN_CHECK_SESSION() {
  return await axiosInstance.get(API_ADMIN_CHECK_SESSION)
}

export async function ADMIN_GET_AUTH() {
  return await axiosInstance.get(API_ADMIN_AUTH)
}

export async function ADMIN_GET_SETTINGS() {
  return await axiosInstance.get(API_ADMIN_SETTINGS)
}
export async function ADMIN_GET_CHATS(member) {
  return await axiosInstance.get(API_ADMIN_CHATS + "/" + member + "/chats")
}

export async function ADMIN_UPDATE_SETTINGS(data) {
  return await axiosInstance.post(API_ADMIN_SETTINGS, data)
}

export async function ADMIN_GET_POINT_SETTINGS() {
  return await axiosInstance.get(API_PUBLIC_SETTINGS + "/points")
}

export async function ADMIN_GET_TAX_SETTINGS() {
  return await axiosInstance.get(API_ADMIN_TAX)
}

export async function ADMIN_UPDATE_TAX_SETTINGS(data) {
  return await axiosInstance.put(API_ADMIN_TAX, data)
}

export async function ADMIN_GET_PICKUP_LIMIT() {
  const paramData = {
    params: {},
  }
  return await axiosInstance.get(API_ADMIN_PICKUP_LIMIT, paramData)
}

export async function ADMIN_UPDATE_PICKUP_LIMIT(data) {
  return await axiosInstance.put(API_ADMIN_PICKUP_LIMIT, data)
}

export async function ADMIN_GET_HOLIDAYS(calendarFrom, calendarTo) {
  return await axiosInstance.get(API_ADMIN_SCHEDULES, {
    params: { from: calendarFrom, to: calendarTo, type: "rest" },
  })
}

export async function ADMIN_GET_NO_TASTE_DAYS(calendarFrom, calendarTo) {
  return await axiosInstance.get(API_ADMIN_SCHEDULES, {
    params: { from: calendarFrom, to: calendarTo, type: "notaste" },
  })
}

export async function ADMIN_CREATE_HOLIDAY(data) {
  return await axiosInstance.put(API_ADMIN_SCHEDULES, data)
}

export async function ADMIN_CREATE_NO_TASTE_DAY(data) {
  return await axiosInstance.put(API_ADMIN_SCHEDULES, data)
}

export async function ADMIN_DELETE_SCHEDULE(data) {
  const paramData = {
    data: data,
  }

  return await axiosInstance.delete(API_ADMIN_SCHEDULES, paramData)
}

export async function ADMIN_GET_RICHMENUS() {
  return await axiosInstance.get(API_ADMIN_RICHMENUS)
}

export async function ADMIN_UPDATE_RICHMENU(data) {
  const headerData = {
    headers: {
      "content-type": "multipart/form-data",
    },
  }

  const formData = new FormData()
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key])
  })

  return await axiosInstance.put(API_ADMIN_RICHMENUS, formData, headerData)
}

export async function ADMIN_UPDATE_RICHMENU_VISIBILITY(data) {
  return await axiosInstance.put(API_ADMIN_RICHMENUS + "/props", data)
}

export async function ADMIN_DELETE_RICHMENU(data) {
  const param = {
    data: {
      type: data.type,
    },
  }

  return await axiosInstance.delete(API_ADMIN_RICHMENUS, param)
}

export async function ADMIN_SEND_CHAT(data) {
  return await axiosInstance.post(
    API_ADMIN_CHATS + "/" + data.memberId + "/chats",
    data,
  )
}
export async function ADMIN_GET_CUSTOMERS(
  paginationPerPage,
  paginationPage,
  paginationSort,
  paginationSortKey,
  filterUserCode,
  filterName,
  filterEmail,
  filterTelephone,
  filterAddress,
  filterLineSynced,
  filterIsFriend,
  filterNotificationPref,
) {
  const paramData = {
    params: {
      pp: paginationPerPage,
      p: paginationPage,
      sort: paginationSort,
      sortKey: paginationSortKey,
      userCode: filterUserCode,
      name: filterName,
      email: filterEmail,
      telephone: filterTelephone,
      address: filterAddress,
      lineSynced: filterLineSynced,
      isFriend: filterIsFriend,
      notificationPref: filterNotificationPref,
    },
  }

  return await axiosInstance.get(API_ADMIN_CUSTOMERS, paramData)
}
export async function ADMIN_GET_CUSTOMER(data) {
  return await axiosInstance.get(API_ADMIN_CUSTOMERS + "/" + data.memberId)
}
export async function ADMIN_GET_PRODUCTS_LIST() {
  const paramData = {
    params: {},
  }

  return await axiosInstance.get(API_ADMIN_PRODUCTS + "/list", paramData)
}

export async function ADMIN_GET_PRODUCTS(
  paginationPerPage,
  paginationPage,
  paginationSort,
  paginationSortKey,
  filterProductCode,
  filterProductName,
  filterIsDisplayed,
) {
  const paramData = {
    params: {
      pp: paginationPerPage,
      p: paginationPage,
      sort: paginationSort,
      sortKey: paginationSortKey,
      productCode: filterProductCode,
      productName: filterProductName,
      isDisplayed: filterIsDisplayed,
    },
  }

  return await axiosInstance.get(API_ADMIN_PRODUCTS, paramData)
}

export async function ADMIN_GET_CATEGORIES() {
  const paramData = {
    params: {},
  }

  return await axiosInstance.get(API_PUBLIC_CATEGORIES, paramData)
}

export async function ADMIN_GET_REPLY_TEMPLATES() {
  const paramData = {
    params: {},
  }

  return await axiosInstance.get(API_ADMIN_REPLY_TEMPLATES, paramData)
}

export async function ADMIN_GET_SHIPMENTS(
  paginationPerPage,
  paginationPage,
  paginationSort,
  paginationSortKey,
  filterTransactionHeadId,
  filterName,
  filterEmail,
  filterTelephone,
  filterAddress,
  filterOrderDateFrom,
  filterOrderDateTo,
  filterShipmentStatus,
) {
  const paramData = {
    params: {
      pp: paginationPerPage,
      p: paginationPage,
      sort: paginationSort,
      sortKey: paginationSortKey,
      transactionHeadId: filterTransactionHeadId
        ? Number(filterTransactionHeadId)
        : undefined,
      name: filterName,
      email: filterEmail,
      telephone: filterTelephone,
      address: filterAddress,
      orderDateFrom: filterOrderDateFrom
        ? moment(filterOrderDateFrom).startOf("day").toISOString()
        : undefined,
      orderDateTo: filterOrderDateTo
        ? moment(filterOrderDateTo).endOf("day").toISOString()
        : undefined,
      shipmentStatus: filterShipmentStatus,
    },
  }

  return await axiosInstance.get(API_ADMIN_SHIPMENTS, paramData)
}
export async function ADMIN_GET_PURCHASES(
  paginationPerPage,
  paginationPage,
  paginationSort,
  paginationSortKey,

  filterOrderDateFrom,
  filterOrderDateTo,
  filterPurchaseStatus,
) {
  const paramData = {
    params: {
      pp: paginationPerPage,
      p: paginationPage,
      sort: paginationSort,
      sortKey: paginationSortKey,

      orderDateFrom: filterOrderDateFrom
        ? moment(filterOrderDateFrom).startOf("day").toISOString()
        : undefined,
      orderDateTo: filterOrderDateTo
        ? moment(filterOrderDateTo).endOf("day").toISOString()
        : undefined,
      purchaseStatus: filterPurchaseStatus,
    },
  }

  return await axiosInstance.get(API_ADMIN_PURCHASES, paramData)
}
export async function ADMIN_GET_PRODUCT_STOCK(
  filterOrderDateFrom,
  filterOrderDateTo,
  filterIsDisplayed,
  paginationSort,
  paginationSortKey,
) {
  const paramData = {
    params: {
      from: filterOrderDateFrom
        ? moment(filterOrderDateFrom).format("YYYY-MM-DD")
        : undefined,
      to: filterOrderDateTo
        ? moment(filterOrderDateTo).format("YYYY-MM-DD")
        : undefined,
      isDisplayed: filterIsDisplayed,
      sort: paginationSort,
      sortKey: paginationSortKey,
    },
  }

  return await axiosInstance.get(API_ADMIN_PRODUCT_STOCK + "/log", paramData)
}

export async function ADMIN_UPDATE_REPLY_TEMPLATE(data) {
  return await axiosInstance.put(API_ADMIN_REPLY_TEMPLATES, data)
}

export async function ADMIN_UPDATE_SHIPMENT(data) {
  return await axiosInstance.put(API_ADMIN_SHIPMENTS, data)
}

export async function ADMIN_IMPORT_SHIPMENTS(data) {
  return await axiosInstance.post(API_ADMIN_SHIPMENTS + "/csv/import", data)
}

export async function ADMIN_EXPORT_SHIPMENT_CSV(data) {
  return await axiosInstance.post(API_ADMIN_SHIPMENTS + "/csv", data)
}

export async function ADMIN_UPDATE_PRODUCT(data) {
  const headerData = {
    headers: {
      "content-type": "multipart/form-data",
    },
  }

  const formData = new FormData()
  formData.append("isDisplayed", data.isDisplayed)
  formData.append("country", data.country || "")
  formData.append("recommendedRoast", data.recommendedRoast || "")
  formData.append("recommendedRoastText", data.recommendedRoastText || "")

  if (data.roasts && data.roasts.length > 0) {
    data.roasts.forEach((roast) => {
      formData.append("roasts[]", roast)
    })
  } else {
    formData.append("roasts", "")
  }

  if (data.grinds && data.grinds.length > 0) {
    data.grinds.forEach((grind) => {
      formData.append("grinds[]", grind)
    })
  } else {
    formData.append("grinds", "")
  }

  if (data.tastes && data.tastes.length > 0) {
    data.tastes.forEach((taste) => {
      formData.append("tastes[]", taste)
    })
  } else {
    formData.append("tastes", "")
  }

  if (data.picData && data.picData.length > 0) {
    data.picData.forEach((imageData) => {
      formData.append("picData[]", imageData)
    })
  } else {
    formData.append("picData", "")
  }

  if (data.picUrl && data.picUrl.length > 0) {
    data.picUrl.forEach((image) => formData.append("picUrl", image))
  } else {
    formData.append("picUrl", "")
  }

  return await axiosInstance.put(
    `${API_ADMIN_PRODUCTS}/${data.productId}`,
    formData,
    headerData,
  )
}

export async function ADMIN_UPDATE_PRODUCT_ORDER(data) {
  return await axiosInstance.put(API_ADMIN_PRODUCTS + "/order", data)
}

export async function ADMIN_IMPORT_PRODUCTS(data) {
  return await axiosInstance.post(API_ADMIN_PRODUCTS + "/csv/import", data)
}

export async function ADMIN_EXPORT_PRODUCT_CSV(data) {
  return await axiosInstance.post(API_ADMIN_PRODUCTS + "/csv/export", data)
}

export async function ADMIN_SYNC_PRICE(data) {
  return await axiosInstance.post(API_ADMIN_PRODUCTS + "/price/sync", data)
}

export async function SMAREGI_LOGIN(data) {
  return await axiosInstance.post(API_ADMIN_AUTH, data)
}
